import { Badge, Card, CardBody, CardTitle, LoadingButton, Typography, } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import '../../../styles/drawer.scss';
import { EditPickupLocationStoreHoursAccordion } from './EditPickupLocationStoreHoursAccordion';
import { useOrderContext } from '../../../hooks/useContexts';
// Showing Closed store scenario and commenting out open store scenario
export var EditPickupLocationStoreCard = function (_a) {
    var _b, _c, _d, _e;
    var store = _a.store, currentStore = _a.currentStore, handleStoreButtonClick = _a.handleStoreButtonClick;
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var currentDrawer = useOrderContext().currentDrawer;
    return (React.createElement(Card, { grow: true },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-between sui--mb-3" },
            React.createElement("span", { style: { width: 'fit-content', paddingBottom: '7px' } }, currentStore ? (React.createElement(Badge, { variant: "regular", size: "small", color: "success", width: "fit-content" }, "Your Selected Store")) : null),
            React.createElement("div", { className: "sui-flex sui-justify-between" },
                React.createElement(CardTitle, { header: React.createElement(Typography, { weight: "bold", variant: "h4", height: "tight" }, store === null || store === void 0 ? void 0 :
                        store.storeName,
                        " #", store === null || store === void 0 ? void 0 :
                        store.storeNumber) }),
                !currentStore ? (React.createElement(Typography, { weight: "bold", style: { alignContent: 'center' } }, store === null || store === void 0 ? void 0 :
                    store.distance,
                    " ", store === null || store === void 0 ? void 0 :
                    store.unit)) : null)),
        React.createElement(CardBody, null,
            React.createElement(Typography, null,
                React.createElement("div", null, (_b = store === null || store === void 0 ? void 0 : store.address) === null || _b === void 0 ? void 0 : _b.addressLine1),
                React.createElement("div", null, (_c = store === null || store === void 0 ? void 0 : store.address) === null || _c === void 0 ? void 0 :
                    _c.city,
                    ", ", (_d = store === null || store === void 0 ? void 0 : store.address) === null || _d === void 0 ? void 0 :
                    _d.stateCode,
                    ' ', (_e = store === null || store === void 0 ? void 0 : store.address) === null || _e === void 0 ? void 0 :
                    _e.zipCode)),
            React.createElement(Typography, null, currentStore && currentDrawer === 'STORE_PICKUP_OPTION' ? (React.createElement(Typography, null,
                React.createElement("div", { className: "sui-my-4 sui-font-bold" }, "Out of Stock"))) : (React.createElement(Typography, null,
                React.createElement("div", { className: "sui-my-4" },
                    React.createElement("span", { className: "sui-font-bold", style: { color: '#0D864C' } },
                        "All items in stock",
                        ' '),
                    "for Pickup")))),
            React.createElement(EditPickupLocationStoreHoursAccordion, { store: store })),
        !currentStore && (React.createElement(LoadingButton, { loading: isLoading, style: { width: '100%', marginTop: '-16px' }, grow: true, fullWidth: true, variant: "secondary", onClick: function () {
                handleStoreButtonClick(setIsLoading, store);
            } }, "Select This Store"))));
};
